// MenuItem.tsx
import React from "react";

interface MenuItemProps {
  label: string;
  href: string;
}

const MenuItem: React.FC<MenuItemProps> = ({ label, href }) => {
  return (
    <a href={href} className="group relative inline-block content-center p-2">
      <span className="text-base transition-all duration-200 group-hover:font-black">
        {label}
      </span>
      <span className="absolute bottom-0 left-0 h-[6px] w-full origin-left scale-x-0 bg-meteoyellow-500 transition-transform duration-200 group-hover:scale-x-100"></span>
    </a>
  );
};

export default MenuItem;
